module.exports = __webpack_public_path__ + "img/Icon-Email Notification.9e4b64a2.svg";